import createStore from './create-store';
import tinker from './tinker';

export default tinker.addTool('store', createStore());
